import Image from "@/components/ui/image";
import { X } from "lucide-react";
import React from "react";

const Footer = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        boxSizing: "border-box",
        padding: "16px",
        background: "#ccc",
        justifyContent: "center",
        alignItems: "center",
        gap: "32px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
        }}
      >
        <p
          style={{
            margin: 0,
            fontFamily: "var(--font-cabin-condensed)",
            fontWeight: "bold",
            color: "#00000085",
          }}
        >
          Powered by
        </p>
        <a
          style={{
            width: "48px",
            height: "48px",
            position: "relative",
            cursor: "pointer",
          }}
          target="_blank"
          href="https://www.0xhoneyjar.xyz/"
        >
          <Image
            draggable={false}
            src="/Home/honey_jar_globe_black.png"
            style={{
              objectFit: "cover",
            }}
            alt=""
            fill
          />
        </a>
      </div>
      <X />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
        }}
      >
        <p
          style={{
            margin: 0,
            fontFamily: "var(--font-cabin-condensed)",
            fontWeight: "bold",
            color: "#00000085",
          }}
        >
          Funded by
        </p>
        <a
          style={{
            width: "48px",
            height: "48px",
            position: "relative",
            cursor: "pointer",
          }}
          target="_blank"
          href="https://www.berachain.com/"
        >
          <Image
            draggable={false}
            src="/Home/BerachainLogo_black.svg"
            style={{ objectFit: "contain" }}
            alt=""
            fill
          />
        </a>
      </div>
    </div>
  );
};

export default Footer;
